(window as any).__Zone_disable_requestAnimationFrame = true; // disable patch requestAnimationFrame
(window as any).__Zone_disable_on_property = true; // disable patch onProperty such as onclick
(window as any).__Zone_disable_geolocation = true;
(window as any).__Zone_disable_blocking = true;
(window as any).__Zone_disable_mediaQuery = true;
(window as any).__Zone_disable_notification = true;
(window as any).__Zone_enable_cross_context_check = true;
(window as any).__Zone_disable_toString = true;
(window as any).__Zone_disable_canvas = true;
(window as any).__Zone_disable_timers = true;
(window as any).__Zone_disable_XHR = true;

let ignored = [
    "online",
    "offline",
    "webglcontextrestored",
    "webglcontextlost",
    "webglcontextcreationerror",
    "mozbeforepaint",
    "userproximity",
    "vrdisplyconnected",
    "vrdisplaydisconnected",
    "vrdisplaypresentchange",
    "afterscriptexecute",
    "beforescriptexecute",
    "fullscreenchange",
    "mozfullscreenchange",
    "webkitfullscreenchange",
    "msfullscreenchange",
    "fullscreenerror",
    "keydown",
    "keyup",
    "mozfullscreenerror",
    "webkitfullscreenerror",
    "msfullscreenerror",
    "languagechange",
    "storage",
    "storagecommit",
    "encrypted",
    "waitingforkey",
    "msneedkey",
    "mozinterruptbegin",
    "mozinterruptend",
    "beforeunload",
    "animationiteration",
    "webkitanimationiteration",
    "canplaythrough",
    "cuechange",
    "contextmenu",
    "curechange",
    "ratechange",
    "afterprint",
    "appinstalled",
    "beforeinstallprompt",
    "deviceproximity",
    "paint",
    "seeked",
    "seeking",
    "durationchange",
    "stalled",
    "timeupdate",
    "msfullscreenchange",
    "msfullscreenerror",
    "hashchange",
    "absolutedeviceorientation",
    "deviceorientationabsolute",
    "rejectionhandled",
    "devicelight",
    "unload",
    "unhandledrejection",
    "devicemotion",
    "sort",
    "play",
    "playing",
    "loadeddata",
    "loadedmetadata",
    "suspend",
    "pointerlockchange",
    "pointerupoutside",
    "pointerover",
    "pointerleave",
    "pointerout",
    "readystatechange",
    "load",
    "progress",
    "mozpointerlockchange",
    "webkitpointerlockerchange",
    "pointerlockerror",
    "mozpointerlockerror",
    "webkitpointerlockerror",
    "compassneedscalibration",
    "msfullscreenchange",
    "msfullscreenerror",
    "MSFullscreenChange",
    "MSFullscreenError",
    "compositionstart",
    "compositionupdate",
    "compositionend",
    "beforeinput",
    "focusin",
    "focusout",
    "volumechange",
    "select",
    "selectionchange",
    "selectstart",
    "mousemove",
    "gotpointercapture",
    "msgotpointercapture",
    "mouseenter",
    "mouseleave",
    "mouseout",
    "mousedown",
    "mouseover",
    "mouseup",
    "pause"
];
(window as any).__zone_symbol__UNPATCHED_EVENTS = ignored;
